/**
 * Removes any key with falsy / empty  values in an object
 * example:- input { freetext: '', minprice: 500}, output:- { minprice: 500}
 * @param obj
 * @returns
 */
export const clean = (obj: any) =>
  // eslint-disable-next-line unicorn/no-array-reduce
  Object.keys(obj).reduce((cleaned: any, key: string) => {
    if (
      (obj[key] && typeof obj[key] === 'object' && Object.keys(obj[key]).length > 0) ||
      (typeof obj[key] !== 'object' && obj[key])
    ) {
      cleaned[key] = obj[key];
    }

    return cleaned;
  }, {});
